export type PaymentMethodBrand =
  | 'Amex'
  | 'Diners'
  | 'Discover'
  | 'JCB'
  | 'Mastercard'
  | 'Union Pay'
  | 'Visa'
  | 'Unknown'

export enum AnalyticEvents {
  actionAddSuccess = 'PORTAL_BILLING_ACTION_ADD_SUCCESS',
  actionRemoveSuccess = 'PORTAL_BILLING_ACTION_REMOVE_SUCCESS',
  actionSwitchSuccess = 'PORTAL_BILLING_ACTION_SWITCH_SUCCESS',
  actionAddError = 'PORTAL_BILLING_ACTION_ADD_ERROR',
}

export interface PaymentMethodDisplayDetails {
  brand?: PaymentMethodBrand
  last4?: string
  expirationMonth?: number
  expirationYear?: number
}

export interface PaymentMethod {
  id: string
  isDefault: boolean
  paymentMethodDisplayDetails: PaymentMethodDisplayDetails
}

export interface PaymentMethods {
  results: PaymentMethod[]
}

export interface SetupIntent {
  setupIntentClientSecret: string
}

export type PaymentMethodRow = {
  id: string
  isSelected: boolean
  brand?: PaymentMethodBrand
  last4?: string
  expirationMonth?: Number
  expirationYear?: Number
}
